import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6880d14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-gem" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_plus_button = _resolveComponent("plus-button")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass({
      'gem-counter': true,
      'gem-counter-background': !_ctx.nobackground,
      'gem-counter-outline': _ctx.outline,
      'gem-counter-small': _ctx.small,
    }),
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: require(`@/assets/images/${_ctx.icon}`),
          alt: _ctx.icon,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imageClicked && _ctx.imageClicked(...args)))
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['text', { red: _ctx.red }]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.imageClicked && _ctx.imageClicked(...args)))
      }, _toDisplayString(_ctx.text), 3),
      (_ctx.plusSign)
        ? (_openBlock(), _createBlock(_component_plus_button, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}